
import { Component, Vue, Prop, Watch, Model } from "vue-property-decorator";
// import { objAny } from "@/common/common-interface";
@Component
export default class SelectStation extends Vue {
  @Prop({
    default: () => {
      return [];
    }
  })
  private numberData!: string[] | number[];
  @Prop({ default: "" }) private minPlaceholder!: string;
  @Prop({ default: "" }) private maxPlaceholder!: string;
  @Watch("numberData")
  getVisible(val: string[]) {
    if (val[0]) {
      this.min = val[0];
    } else {
      this.min = "";
    }
    if (val[1]) {
      this.max = val[1];
    } else {
      this.max = "";
    }
  }

  private min: string | number = "";
  private max: string | number = "";
  @Model("value", { type: Array }) private minMax!: string[] | number[];
  watchValue() {
    const val = this.numberData;
    if (val[0]) {
      this.min = val[0];
    } else {
      this.min = "";
    }
    if (val[1]) {
      this.max = val[1];
    } else {
      this.max = "";
    }
  }

  public inputChange() {
    this.$emit("value", [this.min, this.max]);
    this.$emit("on-change", [this.min, this.max]);
  }
  mounted() {
    this.watchValue();
  }
}
